/**
 * Centre Page rhythm of the day tabs.
 */
(function () {
	'use strict';

	function switchRhythm(slug, clickedButton) {
		var root = document.querySelector('[data-centre-rhythm]');
		if (!root || !slug) {
			return;
		}

		root.querySelectorAll('.rhythm-tab').forEach(function (tab) {
			var isActive = tab.getAttribute('data-rhythm-tab') === slug;
			tab.classList.toggle('active', isActive);
			tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		root.querySelectorAll('[data-rhythm-panel]').forEach(function (panel) {
			var isActive = panel.getAttribute('data-rhythm-panel') === slug;
			panel.classList.toggle('active', isActive);
			if (isActive) {
				panel.removeAttribute('hidden');
			} else {
				panel.setAttribute('hidden', '');
			}
		});

		if (clickedButton) {
			clickedButton.focus();
		}
	}

	window.guardianCentrePageSwitchRhythm = function (slug) {
		switchRhythm(slug, null);
	};

	function init() {
		var root = document.querySelector('[data-centre-rhythm]');
		if (!root) {
			return;
		}

		root.querySelectorAll('[data-rhythm-tab]').forEach(function (button) {
			button.addEventListener('click', function () {
				var slug = button.getAttribute('data-rhythm-tab');
				var age = button.getAttribute('data-age');

				// Drive the page-wide age selection so "Your first weeks" and the
				// personalised content update in sync. Fall back to local-only
				// switching when the age strip is not present on this page.
				if (age && typeof window.guardianCentrePageSelectAge === 'function') {
					window.guardianCentrePageSelectAge(age);
					button.focus();
					return;
				}

				switchRhythm(slug, button);
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
